import { makeStyles } from "@material-ui/core";

import { configs } from "../../configs";
import { fonts } from "../../shared/styles";

const useStyles = makeStyles(({ breakpoints }) => ({
  backgroundImage: {
    alignItems: 'center',
    backgroundImage: `linear-gradient(rgba(52, 52, 52, 0.60) 100%, rgba(52, 52, 52, 0.60) 100%), url(${configs.cdnUrl}/images/life-time-app-promo-bg.png)`,
    backgroundPosition: '65%',
    backgroundSize: 'cover',
    display: 'flex',
    height: '100%',
    minHeight: '588px',
    width: '100%',

    [breakpoints.down('sm')]: {
      backgroundPosition: '80%',
      minHeight: 'unset',
      padding: '34px',
    },
  },
  buttonsContainer: {
    display: 'flex',
    gap: '8px',
    justifyContent: 'space-between',
    marginTop: '24px',

    '& .MuiButton-outlined': {
      border: '2px solid #F4F4F4',
      color: '#F4F4F4',
      fontFamily: fonts.default.fontFamily,
      fontSize: '14px',
      letterSpacing: '-0.28px',
    },
    '& .MuiButton-contained': {
      background: '#15A9E1',
      boxShadow: 'none',
      color: '#FFF',
      fontFamily: fonts.default.fontFamily,
      fontSize: '14px',
      letterSpacing: '-0.28px',
    }
  },
  contentContainer: {
    color: '#fff',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    marginLeft: '63px',
    maxWidth: '311px',
    width: '100%',

    [breakpoints.down('sm')]: {
      marginLeft: 0,
      maxWidth: 'unset',
    },
  },
  contentText: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    marginTop: '24px',

    '& p': {
      color: '#F4F4F4',
      fontFamily: fonts.default.fontFamily,
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: '20px',
      margin: 0,
      padding: 0,
      
      '& span': {
        fontFamily: fonts.heavy.fontFamily,
      }
    }
  },
  footerText: {
    color: '#F4F4F4',
    fontFamily: fonts.default.fontFamily,
    fontSize: '12px',
    fontWeight: 300,
    lineHeight: '20px',
    marginTop: '16px',
  },
  paperFullWidth: {
    borderRadius: '12px',
    maxWidth: '717px',

    [breakpoints.down('sm')]: {
      borderRadius: 0,
      maxWidth: '100%',
    }
  },
}))

export { useStyles }